import DamageScreen from '../components/DamageScreen';
import PolicyDetailScreen from '../components/PolicyDetailScreen';
import SubmitterDetailScreen from '../components/SubmitterDetailScreen';
import ClaimDetailScreen from '../components/ClaimDetailScreen';
import InjuredScreen from '../components/InjuredScreen/InjuredScreen';
import DocumentationScreen from '../components/DocumentationScreen';
import ConfirmationScreen from '../components/ConfirmationScreen';
import { translations } from './consts';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: PolicyDetailScreen,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: SubmitterDetailScreen,
        step: 1,
        label: translations.stepLabel.SUBMITTER,
    },
    {
        path: '/stepThree',
        screen: ClaimDetailScreen,
        step: 2,
        label: translations.stepLabel.DETAILS,
    },
    {
        path: '/stepFour',
        screen: DamageScreen,
        step: 3,
        label: translations.stepLabel.VEHICLE,
    },
    {
        path: '/stepFive',
        screen: InjuredScreen,
        step: 4,
        label: translations.stepLabel.PERSONS,
    },
    {
        path: '/stepSix',
        screen: DocumentationScreen,
        step: 5,
        label: translations.stepLabel.DOCUMENTATION,
    },
    {
        path: '/stepSeven',
        screen: ConfirmationScreen,
        step: 6,
        label: translations.stepLabel.CONFIRMATION,
    },
];

export default stepsComposer;
